import {
	clearSensorGroups,
	getSensorGroups,
} from '@Actions/sensorGroup.action';
import { clearSensorIdsMap } from '@Actions/sensors';
import { SensorGroupsTable } from '@Components';
import RenderComponentOrLoading from '@Components/RenderComponentOrLoading';
import {
	ListSensorGroupsParams,
	SensorGroupsSearchProps,
} from '@Types/sensorGroup.types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SensorGroupTabContainer } from './SensorGroupTab.styles';

const SensorGroupsTab = () => {
	const dispatch = useDispatch();
	const [searchProps, setSearchProps] = useState<SensorGroupsSearchProps>({
		limit: 10,
		offset: 0,
		searchQuery: '',
	});

	useEffect(() => {
		dispatch(clearSensorGroups());
		dispatch(clearSensorIdsMap());
	}, []);

	useEffect(() => {
		const sortBy: string = Object.entries(searchProps.sort || {}).reduce(
			(acc, [key, value]) => `${acc}${key}:${value};`.slice(0, -1),
			'',
		);
		const searchParams: ListSensorGroupsParams = {
			limit: searchProps.limit,
			offset: searchProps.offset,
			searchQuery: searchProps.searchQuery,
			sensorType: searchProps.sensorType,
			sortBy: sortBy || 'lastModifiedDate:desc',
			includeSensorGroupPairs: 'true',
		};
		dispatch(getSensorGroups(searchParams));
	}, [searchProps]);

	return (
		<SensorGroupTabContainer>
			<RenderComponentOrLoading loading={false}>
				<SensorGroupsTable
					searchProps={searchProps}
					setSearchProps={setSearchProps}
				/>
			</RenderComponentOrLoading>
		</SensorGroupTabContainer>
	);
};

export default SensorGroupsTab;
